<div class="fz-odometer-number__digit" [attr.data-number]="number()">
  0 9 8 7 6 5 4 3 2 1 0
</div>
